<div class="treasures-popup">

    <div class="title"><span [ghs-label]="'game.loot.treasures'"></span></div>

    <div class="treasures">
        <div class="treasure" *ngFor="let treasure of treasures; let i = index;"
            [ngClass]="{'looted': looted.indexOf(i) != -1, 'highlight' : i == treasureIndex}"
            (click)="toggleTreasure(i)">
            <span *ngIf="('' + treasure).startsWith('G') || +treasure >= 0"><span
                    *ngIf="!('' + treasure).startsWith('G') && +treasure < 10 && +treasure >= 0">0</span>{{treasure}}</span>
            <span *ngIf="!('' + treasure).startsWith('G') && +treasure < 0">???</span>
            <img class="overlay check" src="./assets/images/check.svg">
        </div>
    </div>

    <div class="characters">
        <div class="character" *ngFor="let char of characters" (click)="toggleCharacter(char)"
            [ngClass]="{'selected' : character == char , 'disabled' : treasures.length == looted.length}">
            <img class="icon" [src]="char.iconUrl" />
            <span class="name">
                {{gameManager.characterManager.characterName(char,true)}}
            </span>

            <div class="treasures">
                <div class="hint-container" *ngFor="let treasure of char.treasures;">
                    <div class="treasure hint-trigger" ghs-pointer-input (doubleClick)="removeTreasure(char,treasure)">
                        <span *ngIf="('' + treasure).startsWith('G') || +(''+treasure).split(':')[0] >= 0">
                            <span *ngIf="!('' + treasure).startsWith('G') && +treasure < 10 && +treasure >= 0">0</span>
                            {{('' + treasure).startsWith('G-') ? 'G' : (''+treasure).split(':')[0]}}
                        </span>
                        <span *ngIf="!('' + treasure).startsWith('G') && +(''+treasure).split(':')[0] < 0">???</span>
                    </div>
                    <span class="hint center">
                        <ghs-treasure-label class="text placeholder text-white"
                            *ngIf="!('' + treasure).startsWith('G-')" [edition]="edition" [index]="+(''
                    +treasure).split(':')[0] -1"
                            [rewardResults]="gameManager.scenarioManager.treasureRewardsFromString('' + treasure)"></ghs-treasure-label></span>
                </div>
            </div>
        </div>
    </div>

    <div class="loot">
        <ng-container
            *ngIf="!!character && treasureIndex != -1 && !gameManager.lootManager.hasTreasure(character, treasures[treasureIndex], treasureIndex)">
            <p><span [ghs-label]="'game.loot.lootTreasure'"
                    [ghs-label-args]="[character.title || '%data.character.' + character.edition + '.'+ character.name + '%', ('' + treasures[treasureIndex]).startsWith('G') || +treasures[treasureIndex] >= 0 ? treasures[treasureIndex] : '\'???\'']"></span>
            </p>
            <div class="button" (click)="lootTreasure()"><span [ghs-label]="'game.loot.lootTreasure.confirm'"></span>
            </div>
        </ng-container>

        <p *ngIf="!!character && treasureIndex == -1"><span [ghs-label]="'game.loot.lootTreasure.selectTreasure'"
                [ghs-label-args]="[character.title || '%data.character.' + character.edition + '.' + character.name + '%']"></span>
        </p>

        <p *ngIf="!character && treasureIndex != -1"><span [ghs-label]="'game.loot.lootTreasure.selectCharacter'"
                [ghs-label-args]="[('' + treasures[treasureIndex]).startsWith('G-') ? 'G' : (+treasures[treasureIndex] >= 0 ? ''
                +treasures[treasureIndex] : '\'???\'')]"></span></p>

        <ng-container
            *ngIf="!!character && treasureIndex != -1 && gameManager.lootManager.hasTreasure(character, treasures[treasureIndex], treasureIndex)">
            <p><span [ghs-label]="'game.loot.lootTreasure.looted'"
                    [ghs-label-args]="[character.title || '%data.character.' + character.edition + '.' + character.name + '%']"></span>
            </p>

            <span *ngIf="treasures[treasureIndex] == 'G'"><span
                    [ghs-label]="'game.loot.treasures.rewards.goal'"></span></span>

            <ghs-treasure-label class="placeholder text-white" *ngIf="treasures[treasureIndex] != 'G'"
                [edition]="edition" [index]="+treasures[treasureIndex] -1" [rewardResults]="rewardResults"
                [itemCards]="true"></ghs-treasure-label>
        </ng-container>
    </div>
</div>